/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const GoogleSheetsIcon = ({
  className,
  style: styleFromProps,
  onClick,
  color = 'white',
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={classNames(className)}
      onClick={onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.35559 9.59989V11.3999H16.7842V9.59989H7.35559Z"
        fill={color}
      />
      <path d="M7.35559 14.4V12.6H9.71274V14.4H7.35559Z" fill={color} />
      <path
        d="M7.35559 15.6001V17.4001H9.71274V15.6001H7.35559Z"
        fill={color}
      />
      <path
        d="M10.8897 15.6001V17.4001H13.2469V15.6001H10.8897Z"
        fill={color}
      />
      <path d="M14.4238 15.6001V17.4001H16.781V15.6001H14.4238Z" fill={color} />
      <path d="M14.4238 14.4V12.6H16.781V14.4H14.4238Z" fill={color} />
      <path d="M13.2469 14.4H10.8897V12.6H13.2469V14.4Z" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6041 0H4.40765C4.25136 0 4.10147 0.0632142 3.99096 0.175736C3.88044 0.288258 3.81836 0.44087 3.81836 0.6V23.4C3.81836 23.5591 3.88044 23.7117 3.99096 23.8243C4.10147 23.9368 4.25136 24 4.40765 24H19.7291C19.8854 24 20.0352 23.9368 20.1458 23.8243C20.2563 23.7117 20.3184 23.5591 20.3184 23.4V4.8H16.1934C16.0371 4.8 15.8872 4.73679 15.7767 4.62426C15.6662 4.51174 15.6041 4.35913 15.6041 4.2V0ZM6.1755 9C6.1755 8.84087 6.23759 8.68826 6.3481 8.57574C6.45861 8.46321 6.6085 8.4 6.76479 8.4H17.3719C17.5282 8.4 17.6781 8.46321 17.7886 8.57574C17.8991 8.68826 17.9612 8.84087 17.9612 9V18C17.9612 18.1591 17.8991 18.3117 17.7886 18.4243C17.6781 18.5368 17.5282 18.6 17.3719 18.6H6.76479C6.6085 18.6 6.45861 18.5368 6.3481 18.4243C6.23759 18.3117 6.1755 18.1591 6.1755 18V9Z"
        fill={color}
      />
      <path
        d="M19.9757 3.59964H16.7853V0.351243L19.9757 3.59964Z"
        fill={color}
      />
    </svg>
  );
};
